(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
(() => {
  const input = document.getElementById('BrandSearch');
  const directory = document.getElementById('BrandDirectory');
  if (!input || !directory) return;
  const status = document.getElementById('BrandSearchCount');
  const normalise = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
  const sections = Array.from(directory.querySelectorAll('section'));
  const items = Array.from(directory.querySelectorAll('li')).map(node => ({node, name: normalise(node.textContent)}));
  const update = () => {
    const term = normalise(input.value);
    let count = 0;
    items.forEach(item => {item.node.hidden = !item.name.includes(term); if (!item.node.hidden) count++;});
    sections.forEach(section => {section.hidden = !Array.from(section.querySelectorAll('li')).some(item => !item.hidden);});
    const nav = directory.querySelector('nav');
    if (nav) nav.hidden = Boolean(term);
    status.textContent = count === 1 ? status.dataset.one : count ? status.dataset.results.replace('[count]', count) : status.dataset.empty;
  };
  input.addEventListener('input', update);
  document.getElementById('BrandSearchClear').addEventListener('click', () => {input.value = ''; update(); input.focus();});
  update();
})();

  } catch(e) { console.error(e); }
})();
})();
